import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableBalanceHistorysView.
 * @extends JetView
 */
export default class tableBalanceHistorysView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Marks old values based on specified conditions.
         * @param {number} value - The value to evaluate.
         * @param {Object} config - The configuration object.
         * @returns {Object} CSS styles for the background.
         */
        function mark_old(value, config) {
            var num = webix.Number.parse(value, {
                decimalSize: 2,
                groupSize: 3,
                decimalDelimiter: '.',
                groupDelimiter: ',',
            });
            if (num > 30 && num < 99) {
                return { background: 'orange' }; // Orange background for values between 30 and 99
            }
            if (num > 100) {
                return { background: 'red' }; // Red background for values greater than 100
            }
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable component
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            scheme: {
                                $change: function (item) {
                                    // Change event for item updates
                                    if (item.BalanceEnd != item.BalanceEndCalc) {
                                        item.$css = { background: '#FFAAAA' }; // Highlight background if balances do not match
                                        if (item.BalanceEnd > item.BalanceEndCalc) {
                                            item.BalanceGap = item.BalanceEnd - item.BalanceEndCalc; // Calculate balance gap
                                        } else {
                                            item.BalanceGap = item.BalanceEndCalc - item.BalanceEnd; // Calculate balance gap
                                        }
                                    }
                                },
                            },
                            columns: [
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de creación'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj, common) {
                                        // Template function for rendering cell content
                                        if (obj.$group) return common.treetable(obj, common) + obj.value;
                                        return obj.CreatedLocalDate; // Return creation date
                                    },
                                },
                                {
                                    id: 'Country', // Column ID
                                    header: _('País'), // Column header with localization
                                    hidden: !devConfig.getPermAction('sensitiveInformationCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        return (
                                            "<i class='flags " + obj.Country + "'></i>" // Render country flag
                                        );
                                    },
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Nombre Usuario'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: !devConfig.getPermAction('sensitiveInformationName', 'Add'), // Conditional visibility based on permissions
                                },
                                {
                                    id: 'BalanceInitial', // Column ID
                                    header: _('Saldo Inicial'), // Column header with localization
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                },
                                {
                                    id: 'InitialRechargeQuota', // Column ID
                                    header: _('Cupo recargas inicial'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'InitialGameQuota', // Column ID
                                    header: _('Cupo juego inicial'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'AmountDeposits', // Column ID
                                    header: _('Depósitos'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'AmountBets', // Column ID
                                    header: _('Ap. Deportivas'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'AmountWin', // Column ID
                                    header: _('Pr. Deportivas'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'AmountWinCasino', // Column ID
                                    header: _('Transf Apuesta E'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'AmountBetsCasino', // Column ID
                                    header: _('Transf Apuesta S'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'AdjustmentE', // Column ID
                                    header: _('Transf Recarga E'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'AdjustmentS', // Column ID
                                    header: _('Transf Recarga S'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'WithdrawPaid', // Column ID
                                    header: _('Retiros Pagados'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'WithdrawDeletes', // Column ID
                                    header: _('Recargas Eliminadas'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'BalanceEnd', // Column ID
                                    header: _('Saldo Final'), // Column header with localization
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'BalanceEndCalc', // Column ID
                                    header: _('Saldo Final Calc.'), // Column header with localization
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'BalanceGap', // Column ID
                                    header: _('Calc. Desfase'), // Column header with localization
                                    width: 110, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    cssFormat: mark_old, // Custom CSS formatting function
                                },
                                {
                                    id: 'EndGameQuota', // Column ID
                                    header: _('Cupo'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'EndGameQuotaCalc', // Column ID
                                    header: _('Cupo Calc.'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for data
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Event triggered before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Event triggered after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event triggered when the component is ready
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>', // Show no data overlay
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'es/BalanceHistory/GetBalanceHistoryBetShop'; // API endpoint for data fetching
        var filter = ''; // Filter string for API requests

        grid.attachEvent('onAfterLoad', function () {
            // Event triggered after data is loaded
            $$('datatable').data.group({
                by: 'UserName', // Grouping by UserName
                map: {
                    UserName: ['UserName'],
                    Country: ['Country'],
                    UserId: ['UserId'],
                    BalanceInitial: ['BalanceInitial', 'sum'],
                    InitialRechargeQuota: ['InitialRechargeQuota', 'sum'],
                    InitialGameQuota: ['InitialGameQuota', 'sum'],
                    AmountDeposits: ['AmountDeposits', 'sum'],
                    AmountBets: ['AmountBets', 'sum'],
                    AmountWin: ['AmountWin', 'sum'],
                    AmountWinCasino: ['AmountWinCasino', 'sum'],
                    AmountBetsCasino: ['AmountBetsCasino', 'sum'],
                    AdjustmentE: ['AdjustmentE', 'sum'],
                    AdjustmentS: ['AdjustmentS', 'sum'],
                    WithdrawPaid: ['WithdrawPaid', 'sum'],
                    WithdrawDeletes: ['WithdrawDeletes', 'sum'],
                    BalanceEnd: ['BalanceEnd', 'sum'],
                    BalanceEndCalc: ['BalanceEndCalc', 'sum'],
                    BalanceGap: ['BalanceGap', 'sum'],
                    EndRechargeQuota: ['EndRechargeQuota', 'sum'],
                    EndRechargeQuotaCalc: ['EndRechargeQuotaCalc', 'sum'],
                    EndGameQuota: ['EndGameQuota', 'sum'],
                    EndGameQuotaCalc: ['EndGameQuotaCalc', 'sum'],
                },
            });
        });

        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            // Event triggered for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    // Check for Type filter
                    if (object[i][1] == 0) {
                        grid.showColumn('UserId', { spans: true }); // Show UserId column
                        grid.showColumn('UserName', { spans: true }); // Show UserName column
                    } else {
                        grid.hideColumn('UserId', { spans: true }); // Hide UserId column
                        grid.hideColumn('UserName', { spans: true }); // Hide UserName column
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object filter values to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(grid); // Log the grid object
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
            $$('filterPopup').hide(); // Hide filter popup
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event triggered after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event triggered on item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event triggered when a player is selected
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
